import { render, staticRenderFns } from "./LastMileForwardLeg.vue?vue&type=template&id=4c169e89"
import script from "./LastMileForwardLeg.vue?vue&type=script&lang=js"
export * from "./LastMileForwardLeg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports